import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { CountryService } from 'src/app/services/country.service';
import { CityService } from 'src/app/services/city.service';
import { ZoneService } from 'src/app/services/zone.service';

@Component({
  selector: 'app-list-lojas',
  templateUrl: './list-lojas.component.html',
  styleUrls: ['./list-lojas.component.css']
})
export class ListLojasComponent implements OnInit {

  eventsSubject: Subject<any> = new Subject<any>();


  displayedColumns: string[] = ['name', 'identifier', 'zone.city.country', 'zone.city', 'zone',   'status', 'actions'];
  imageColumn = [ {field: 'photo', header: 'Logo'}]
  columnsToDisplay = [{field: 'name', header: 'Nome', type: 'text'},
    {field: 'identifier', header: 'Identificador', type: 'text'}];
    columnsObject = [
      {field: 'zone', header: 'Zona', type: 'select', selectID:'id', selectFieldsDados: [], object:'zone', subObject:'name'},
   ];
   columnsObject2 = [
       {field: 'zone.city', header: 'Cidade', type: 'select', selectID:'id', selectFieldsDados: [], object:'zone', object2:'city', subObject:'name'},
   ]
   columnsObject3 = [
    {field: 'zone.city.country', header: 'País', type: 'select', selectID:'id', selectFieldsDados: [], object:'zone', object2:'city', object3:'country', subObject:'name'},
]
    columnsBadge = [{field: 'status', header: 'Estado', type: 'select', selectFieldsDados:  [ {name: 'Ativo', val: 'ACTIVE'}, {name: 'Inativo', val: 'INACTIVE'}]}];
    options = {edit: true, view: true, delete: true, statusUpdate: true};
  title = 'Lojas';
  novo = {link: '/lojas/criar', nome: 'Nova Loja'};
  page: any = {base: null, name: null};
  service;

  constructor(private storeService: StoreService,
    private route: ActivatedRoute,
    private cityService: CityService,
    private zoneService : ZoneService,
    private countryService : CountryService,
    private confirmationDialogService: ConfirmationDialogService,
    private toast: ToastrService,
    private router: Router,) {
this.service = this.storeService.getAll;
this.countryService.getAll({status: "ACTIVE"}).pipe(first())
    .subscribe(
        data => {
          console.log('data', data);
          this.columnsObject3[0].selectFieldsDados = data['content'];
        },
        error => {
          console.log('error', error);
      });
this.cityService.getAll({status: "ACTIVE"}).pipe(first())
  .subscribe(
      data => {
        console.log('data', data);
        this.columnsObject2[0].selectFieldsDados = data['content'];
      },
      error => {
        console.log('error', error);
    });
this.zoneService.getAll({status: "ACTIVE"}).pipe(first())
  .subscribe(
      data => {
        console.log('data', data);
        this.columnsObject[0].selectFieldsDados = data['content'];
      },
      error => {
        console.log('error', error);
    });
}

ngOnInit(): void {
  this.page.base = this.route.data['value'].base;
  this.page.name = this.route.data['value'].routeName;
  }

  edit = (args: any): void => {
    console.log(args);
    this.router.navigate([this.page.base  + '/editar'], { queryParams: { id: args.storeId } });
    }
    view = (args: any): void => {
      console.log(args);
      this.router.navigate([this.page.base  + '/view'], { queryParams: { id: args.storeId } });
    }
    changeStatus = (args: any): void => {
    let textConfirm = '';
    let status = '';
    let textShow = '';

    let service;
    if (args.status === 'ACTIVE'){
      service = this.storeService.inactive(args.storeId);
      textConfirm = 'Pretende Desactivar a Loja ' + args.name + '? Ao desactivar a Loja o estado da Loja será alterado para INATIVO.';
      status = 'INACTIVE';
      textShow = 'LOJA DESATIVADO COM SUCESSO';
    }
    else{
      service = this.storeService.active(args.storeId);
      textConfirm = 'Pretende Activar a Loja ' + args.name + '? Ao activar a Loja o estado da Loja será alterado para ATIVO';
      status = 'ACTIVE';
      textShow = 'LOJA ACTIVADO COM SUCESSO';
    }

    this.confirmationDialogService.confirm('Por favor confirme', textConfirm)
    .then((confirmed) =>
    {
      if (confirmed){
        service.subscribe((event: any) => {
          this.toast.warning(textShow, 'Mudança de Estado');
          args.status = status;
      });
      }
    }
    )
    .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

    delete = (total: any, args: any, index: number): void => {
      this.confirmationDialogService.confirm('Por favor confirme', 'Pretende apagar esta Loja ' + args.name + '? Ao eliminar os dados da Loja serão perdidos!!')
      .then((confirmed) =>
      {
        if (confirmed){
          const indexo = total.indexOf(args);
          this.storeService.delete(args.storeId).pipe(first())
      .subscribe(
          data => {
            this.toast.warning('Eliminado com sucesso', 'Delete');
            total.splice(indexo, 1);
            console.log('total', total);
            this.eventsSubject.next(total);
          },
          error => {
              console.log('error', error);
          });
        }
      }
      )
      .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
      console.log(args);
    }

  }
